import routes from "../../common/api-routes";
import {HttpAuthGet, HttpAuthPost, HttpAuthPutParams, HttpAuthDelete} from "../../../../../core/services/common/HttpRequestBuilder";

const listProfileGatePassConfiguration = (parameters) => {
    let result = HttpAuthGet(routes.LIST_PROFILE_GATEPASS_CONFIGURATION, parameters);
    return result;
}

const createProfileGatePassConfiguration = (payload) => {
    let result = HttpAuthPost(routes.ADD_PROFILE_GATEPASS_CONFIGURATION, payload);
    return result;
}

const viewProfileGatePassConfiguration = (parameters) => {
    let result = HttpAuthGet(routes.VIEW_PROFILE_GATEPASS_CONFIGURATION, parameters);
    return result;
}

const updateProfileGatePassConfigurationStatus = (parameters) => {
    let result = HttpAuthPutParams(routes.UPDATE_STATUS_PROFILE_GATEPASS_CONFIGURATION, parameters);
    return result;
}

const deleteProfileGatePassConfiguration = (parameters) => {
    let result = HttpAuthDelete(routes.DELETE_PROFILE_GATEPASS_CONFIGURATION, parameters);
    return result;
}

const updateProfileGatePassConfigurationDetails = (parameters) => {
    let result = HttpAuthPutParams(routes.UPDATE_DETAILS_PROFILE_GATEPASS_CONFIGURATION, parameters);
    return result;
}



const GatePassConfigurationService = {
    listProfileGatePassConfiguration: listProfileGatePassConfiguration,
    createProfileGatePassConfiguration: createProfileGatePassConfiguration,
    viewProfileGatePassConfiguration: viewProfileGatePassConfiguration,
    updateProfileGatePassConfigurationStatus: updateProfileGatePassConfigurationStatus,
    deleteProfileGatePassConfiguration: deleteProfileGatePassConfiguration,
    updateProfileGatePassConfigurationDetails:  updateProfileGatePassConfigurationDetails
}

export default GatePassConfigurationService